export const removeAccents = (value) =>
  value == null ? value : String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const normalizeSpecialty = (value) =>
  removeAccents(String(value ?? '').trim().toLowerCase());

export const buildSpecialtiesWithExtras = (specialties = [], items = []) => {
  const seen = new Set(specialties.map((option) => normalizeSpecialty(option.label)));
  const extras = [];

  (items || []).forEach((item) => {
    String(item?.especialidad ?? '')
      .split(',')
      .forEach((part) => {
        const label = part.trim();
        const key = normalizeSpecialty(label);
        if (label && !seen.has(key)) {
          seen.add(key);
          extras.push({ value: label, label });
        }
      });
  });

  return [...specialties, ...extras];
};

export const getSpecialtiesFromList = (value, specialties = []) => {
  const parts = String(value ?? '').split(',');
  const matched = parts
    .map((part) => {
      const match = specialties.find(
        (option) => normalizeSpecialty(option.label) === normalizeSpecialty(part)
      );
      return match ? match.label : null;
    })
    .filter(Boolean);

  if (matched.length) return matched.join(', ');
  return parts.map((part) => part.trim()).filter(Boolean).join(', ');
};

export const getSpecialtyName = (value, specialties = []) =>
  specialties.find((option) => String(option.value) === String(value))?.label ?? value;
